import React, { useState } from "react";
import { Button, Flex, Input, Select } from "@chakra-ui/react";
import Card from "horizon/components/card/Card";
import { ACTION_FILTER_OPTIONS } from "./auditLogConstants";

const EMPTY_DRAFT = { action: "", admin_id: "", target_user_id: "", start_date: "", end_date: "" };

/**
 * Filter bar for the audit log: action, acting admin id, target user id and a
 * created_at date range. Calls onApply with the draft filters.
 * @param {Object} props - onApply (fn called with the draft filters)
 * @returns {React.ReactElement}
 */
function AuditLogFilters({ onApply }) {
  const [draft, setDraft] = useState(EMPTY_DRAFT);
  const set = (key) => (e) => setDraft({ ...draft, [key]: e.target.value });
  return (
    <Card>
      <Flex wrap="wrap" gap="12px" align="center">
        <Select w="200px" size="sm" borderRadius="10px" value={draft.action} onChange={set("action")}>
          {ACTION_FILTER_OPTIONS.map((opt) => (
            <option key={opt.value || "all"} value={opt.value}>{opt.label}</option>
          ))}
        </Select>
        <Input w="120px" size="sm" borderRadius="10px" type="number" placeholder="ID admin"
          value={draft.admin_id} onChange={set("admin_id")} />
        <Input w="140px" size="sm" borderRadius="10px" type="number" placeholder="ID user cible"
          value={draft.target_user_id} onChange={set("target_user_id")} />
        <Input w="160px" size="sm" borderRadius="10px" type="date"
          value={draft.start_date} onChange={set("start_date")} />
        <Input w="160px" size="sm" borderRadius="10px" type="date"
          value={draft.end_date} onChange={set("end_date")} />
        <Button size="sm" colorScheme="brand" onClick={() => onApply(draft)}>Appliquer</Button>
      </Flex>
    </Card>
  );
}

export default AuditLogFilters;
